// import _ from 'lodash'

import Vue from 'vue'
import VueI18n from 'vue-i18n'

// *****************************************************************************

Vue.use(VueI18n)

const messages = {
  en: {
    add: 'Add',
    substract: 'Substract',

    // modify_short_tooltip: 'Modify',
    // modify_full_tooltip: 'Goes to brick edition',
    // modify_navbar: 'Modify',

    // delete_short_tooltip: 'Delete',
    // delete_full_tooltip: 'Deletes the brick',
    // delete_navbar: 'Delete',

    // cancel_short_tooltip: 'Cancel',
    // // s ?
    // cancel_full_tooltip: 'Cancels the selection',
    // cancel_navbar: 'Cancel',

    autofe_short_tooltip: 'Automatic FE',
    autofe_full_tooltip: 'Automatic feature engineering',
    autofe_navbar: 'Automatic FE',

    join_short_tooltip: 'Join',
    // bis repetitam s
    join_full_tooltip: 'Joins tables',
    join_navbar: 'Join',

    pivot_short_tooltip: 'Pivot',
    // bis repetitam s
    pivot_full_tooltip: 'Pivots a table',
    pivot_navbar: 'Pivot',

    output_short_tooltip: 'Output',
    output_full_tooltip: 'Outputs something...',
    output_navbar: 'output',

    list_available_headers: 'List of available tables',
    please_choose_a_table: 'Please choose a table',
    choose_a_table: 'Choose a table',
    chosen_table: 'Chosen table :',
    choose_a_column: 'Choose a column',
    choose_a_type: 'Choose a type',
    choose_a_value: 'Choose a value',
    choose_a_database: 'Choose a database',
    enter_manual_column: 'Enter a column name manually',
    table_chosen: 'Table chosen :',
    available_tables: 'List of available tables',
    available_columns: 'List of available columns',
    selected_columns: 'List of selected columns',
    columns_listing: 'Columns listing',
    index_columns: 'Index columns',

    periodicity_column: 'Periodicity column',
    periodicity_column_tooltip:
      'The values in this column must be at the YYYYMM format',
    advanced_options_choice: 'Advanced options',

    number: 'Number',
    text: 'Text',
    date: 'Date',
    boolean: 'Boolean',
    formula: 'Formula',
    name: 'Name',
    comma: 'Comma',
    semicolon: 'Semicolon',
    yes: 'Yes',
    no: 'No',
    feature_importance: 'Feature importance',
    currently_computing: 'Currently computing',
    column_name_wanted: 'Name of the wanted column',
    enter_column_name: 'Enter the name of the column you want',
    column_name: 'Column name',
    initial_type: 'Initial type',
    final_type: 'Final type',
    false: 'False',
    true: 'True',
    type: 'Type',
    values: 'Valeurs',
    category: 'Category',
    unknown: 'Unknown',
    // cww_column_name_overridden:
    //   'The column name chosen already exists, it will overwrite the column',
    error_summary: 'Errors and warnings summary',

    cancel: 'Cancel',
    apply: 'Apply',
    ok: 'OK',
    confirm: 'Confirm',
    back_to_workflow: 'Go back to workflow',

    train: 'Training',
    eval: 'Evaluation',
    manual: 'Manual',
    show_snapshots: 'Project snapshots',

    created: 'Created',
    saved: 'Saved',
    bricks: 'bricks',
    save_changes: 'Save changes',

    select_all: 'Select all',

    user: 'User',
    cwsw_unknown_file_type: 'Unknown file type, will be handled as CSV',

    synchronous: 'Synchronous',
    asynchronous: 'Asynchronous',
    endpoint: 'Endpoint',
    coercion: 'Coercion',
    full_answer_path: 'Answer with full URL path',

    metavariables_definition: 'Metavariables definition',
    metavariables_listing: 'Metavariables listing',
    metavariables: 'Metavariables',
    project_status: 'Project Status',
    project_name: 'Project Name',
    project_rights: 'Project Rights',
    in_production: 'In production',

    platform_rights: 'Platform rights',
    platform_admin: 'Platform administration',

    users_and_rights: 'Users and platform rights',
    username: 'Username',
    password: 'Password',
    group: 'Group',
    admin: 'Admin',
    writer: 'Write',
    reader: 'Read',
    user_id: 'User Id',

    change_password: 'Change password',
    old_password: 'Old password',
    new_password: 'New password',
    password_confirmation: 'Confirm password',
    modify_password: 'Modify the password',
    password_confirmation_error:
      "New password and its confirmation don't match",
    password_change_success: 'Password changed successfully',
    password_change_error: 'Old password is incorrect',

    create_user: 'Create a new user',

    text_unsaved_changes:
      'Are you sure you want to leave the page despite your unsaved changes ?',
    preview: 'Preview',
    start: 'Start',
    stop: 'Stop',
    step: 'Step',

    output: 'Output',
    error: 'Error',
  },
  fr: {
    add: 'Ajouter',
    substract: 'Retirer',

    // modify_short_tooltip: 'Modifier',
    // modify_full_tooltip: 'Editer la brique',
    // modify_navbar: 'Modifier',

    // delete_short_tooltip: 'Supprimer',
    // delete_full_tooltip: 'Supprime la brique',
    // delete_navbar: 'Supprimer',

    // cancel_short_tooltip: 'Annuler',
    // cancel_full_tooltip: 'Annule la sélection',
    // cancel_navbar: 'Annuler',

    vstack_short_tooltip: 'Empilement vertical',
    vstack_full_tooltip:
      'Concaténation verticale de plusieurs tables (i.e. avec des colonnes dont le même nom représente la même entité au sein de toutes ces tables)',
    vstack_navbar: 'Empilement vertical',

    autofe_short_tooltip: 'FE Automatique',
    autofe_full_tooltip: 'Feature engineering automatique',
    autofe_navbar: 'FE Automatique',

    join_short_tooltip: 'Jointure',
    join_full_tooltip: 'Rapproche des tables',
    join_navbar: 'Jointure',

    pivot_short_tooltip: 'Pivot',
    pivot_full_tooltip: 'Pivote une table',
    pivot_navbar: 'Pivot',

    output_short_tooltip: 'Sortie',
    output_full_tooltip: 'Sort quelque chose...',
    output_navbar: 'Sortie',

    list_available_headers: 'Liste des tables disponibles',
    please_choose_a_table: 'Veuillez choisir une table',
    choose_a_table: 'Choisissez une table',
    chosen_table: 'Table choisie :',
    choose_a_column: 'Choisissez une colonne',
    choose_a_type: 'Choisissez un type',
    choose_a_value: 'Choisissez une valeur',
    choose_a_database: 'Choisissez une base de données',
    enter_manual_column: 'Entrer un nom de colonne manuellement',
    table_chosen: 'Table choisie :',
    available_tables: 'Liste des tables disponibles',
    available_columns: 'Liste des colonnes disponibles',
    selected_columns: 'Liste des colonnes sélectionnées',
    columns_listing: 'Liste des colonnes',
    index_columns: "Colonnes d'index",

    periodicity_column: 'Colonne de périodicité',
    periodicity_column_tooltip:
      'Les valeurs de cette colonne doivent être au format AAAAMM',
    advanced_options_choice: 'Options avancées',

    number: 'Nombre',
    text: 'Texte',
    date: 'Date',
    boolean: 'Booléen',
    formula: 'Formule',
    name: 'Nom',
    comma: 'Virgule',
    semicolon: 'Point-virgule',
    yes: 'Oui',
    no: 'Non',
    feature_importance: 'Importance des features',
    currently_computing: 'En cours de calcul',
    column_name_wanted: 'Nom de la colonne souhaité',
    enter_column_name: 'Entrez le nom de la colonne que vous souhaitez',
    column_name: 'Column name',
    initial_type: 'Type initial',
    final_type: 'Type final',
    false: 'Faux',
    true: 'Vrai',
    type: 'Type',
    values: 'Valeurs',
    category: 'Catégorie',
    unknown: 'Inconnu',
    // cww_column_name_overridden:
    //   "Le nom de colonne choisi existe déjà, la colonne d'origine sera supprimée",
    error_summary: 'Résumé des erreurs et avertissements',

    cancel: 'Annuler',
    apply: 'Appliquer',
    ok: 'Valider',
    confirm: 'Confirmer',
    back_to_workflow: 'Retourner au workflow',

    train: 'Entrainement',
    eval: 'Evaluation',
    manual: 'Manuel',
    show_snapshots: 'Points de sauvegarde du projet',

    created: 'Créé',
    saved: 'Sauvegardé',
    bricks: 'briques',

    save_changes: 'Sauvegarder les changements',

    select_all: 'Tout sélectionner',

    user: 'Utilisateur',
    cwsw_unknown_file_type:
      'Extension de fichier inconnue, sera considérée comme un CSV',

    synchronous: 'Synchrone',
    asynchronous: 'Asynchrone',
    endpoint: 'Endpoint',
    coercion: 'Coercion',
    full_answer_path: 'Répondre avec une URL complète',

    metavariables_definition: 'Définition des métavariables',
    metavariables_listing: 'Liste des métavariables',
    metavariables: 'Métavariables',

    project_status: 'Statut du projet',
    project_name: 'Nom du projet',
    project_rights: 'Droits sur le projet',
    in_production: 'En production',

    platform_rights: 'Droits plateforme',
    platform_admin: 'Administration de la plateforme',

    users_and_rights: 'Utilisateurs et droits plateforme',
    username: 'Login',
    password: 'Mot de passe',
    group: 'Groupe',
    admin: 'Administrateur',
    writer: 'Exploitant',
    reader: 'Etude',
    user_id: 'Id Utilisateur',

    change_password: 'Changement de mot de passe',
    old_password: 'Ancien mot de passe',
    new_password: 'Nouveau mot de passe',
    password_confirmation: 'Confirmation du nouveau mot de passe',
    modify_password: 'Changer le mot de passe',
    password_confirmation_error:
      'Le nouveau mot de passe et sa confirmation sont différents',
    password_change_success: 'Mot de passe changé avec succès',
    password_change_error: "L'ancien mot de passe est incorrect",

    create_user: 'Créer un nouvel utilisateur',

    text_unsaved_changes:
      'Voulez-vous quitter la page malgré vos changements non sauvegardés ?',
    preview: 'Aperçu',

    start: 'Début',
    stop: 'Fin',
    step: 'Pas',

    output: 'Sortie',
    error: 'Erreur',
  },
}

// function merge_messages(lhs, rhs) {
//   let res = {}
//   for (const [language, mapping] of Object.entries(lhs)) {
//     res[language] = _.assign({}, mapping, rhs[language])
//   }
//   return res
// }

// const messages = merge_messages(menu_messages, i18n_router_messages)

// const messages = menu_messages

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages,
})

// *****************************************************************************

// We need to export it so that we can initialize Vue with it
// and also use automatic translation outside of any component context
export default i18n
